export default __webpack_public_path__ + "static/media/mobile_menu_hamburger.81f5d2f8.svg";